import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Ticket, MapPin, Calendar } from "lucide-react";
import { endpoints } from "@/lib/api";
import { AdSlot } from "@/components/AdSlot";

const fmt = (iso) => (iso ? new Date(iso).toLocaleDateString(undefined, { day: "numeric", month: "short", year: "numeric" }) : "");

export default function Events() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => { endpoints.events().then((r) => setEvents(r.data.events || [])).catch(() => {}).finally(() => setLoading(false)); }, []);

  return (
    <div className="px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto py-10">
      <div className="flex items-center gap-2 mb-2"><Ticket className="w-7 h-7 text-[#E11D2A]" /><h1 className="text-3xl sm:text-4xl font-extrabold text-white">Events & Tickets</h1></div>
      <p className="text-slate-400 text-sm mb-8">Get your tickets for B&B KIGALI events. Every ticket has a unique QR for entry.</p>
      <AdSlot placement="events" position="top" className="mb-8" />
      {loading ? (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">{[0, 1, 2].map((i) => <div key={i} className="aspect-[4/3] rounded-2xl bg-[#121620] animate-pulse" />)}</div>
      ) : events.length === 0 ? (
        <div className="text-center py-20 text-slate-500" data-testid="events-empty">No events on sale right now. Stay tuned!</div>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="events-list">
          {events.map((ev) => {
            const from = Math.min(...(ev.categories.length ? ev.categories.map((c) => c.price) : [0]));
            return (
              <Link key={ev.id} to={`/events/${ev.id}`} data-testid={`event-card-${ev.id}`} className="group rounded-2xl overflow-hidden bg-[#121620] border border-[#273042] card-hover flex flex-col">
                <div className="aspect-video relative overflow-hidden bg-[#0A0C10]">
                  <img src={ev.coverUrl || "/bb-logo.png"} alt={ev.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" onError={(e) => { e.currentTarget.src = "/bb-logo.png"; }} />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent" />
                  {ev.status === "closed" && <div className="absolute top-3 left-3 text-[10px] font-extrabold uppercase px-2 py-1 rounded bg-slate-700 text-slate-200">Sales closed</div>}
                </div>
                <div className="p-4 flex-1 flex flex-col">
                  <div className="text-white font-bold">{ev.title}</div>
                  <div className="text-xs text-slate-400 mt-2 space-y-1 flex-1">
                    <div className="flex items-center gap-1.5"><Calendar className="w-3.5 h-3.5" /> {fmt(ev.startAt)}</div>
                    {ev.venue && <div className="flex items-center gap-1.5"><MapPin className="w-3.5 h-3.5" /> {ev.venue}</div>}
                  </div>
                  <div className="mt-3 text-[#F5B301] font-extrabold">From {from.toLocaleString()} RWF</div>
                </div>
              </Link>
            );
          })}
        </div>
      )}
      <AdSlot placement="events" position="bottom" className="mt-8" />
    </div>
  );
}
